import './array.at.polyfill'
import './array.find.polyfill'
import './array.from.polyfill'
import './array.includes.polyfill'
import './array.some.polyfill'
import './object.assign.polyfill'
import './object.values.polyfill'
import './string.at.polyfill'
import './string.endsWith.polyfill'
